import React, { useEffect,  useRef } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../lib/animate/animate.css';
import '../lib/lightbox/css/lightbox.min.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import brand1 from "../img/brand1.png"
import brand2 from "../img/brand2.jpg"
import brand3 from "../img/brand3.png"
import brand4 from "../img/brand4.png"
import brand5 from "../img/apclogo.png"
const Features = () => {
  // const [experience, setExperience] = useState(0);
  // const [awards, setAwards] = useState(0);
  // const [totalAnimals, setTotalAnimals] = useState(0);
  // const [happyClients, setHappyClients] = useState(0);
  const sectionRef = useRef(null); 

  useEffect(() => {
    const counters = [
      // { target: 25, setCount: setExperience },
      // { target: 183, setCount: setAwards },
      // { target: 2619, setCount: setTotalAnimals },
      // { target: 51940, setCount: setHappyClients },
    ];

    // Function to start counting
    const startCounting = () => {
      counters.forEach(({ target, setCount }) => {
        let count = 0;
        const increment = Math.ceil(target / 50);
        const duration = 2000;
        const intervalTime = duration / 100;

        const interval = setInterval(() => {
          count += increment;
          if (count >= target) {
            count = target;
            clearInterval(interval);
          }
          setCount(count);
        }, intervalTime);
      });
    };

    // Setup Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startCounting(); 
          observer.unobserve(entry.target); 
        }
      });
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current); 
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className="container-xxl py-5">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <p className="section-title bg-white text-start text-primary pe-3">Why Us!</p>
            <h1 className="mb-4">Few Reasons Why People Choosing Us!</h1>
            <p><i className="fa fa-check text-primary me-3"></i><b><u>Wide Selection:</u></b> <br/> We offer a comprehensive range of batteries for every need—whether for electronics, vehicles, or renewable energy solutions. Whatever you’re looking for, we have it.</p>
            <p><i className="fa fa-check text-primary me-3"></i><b><u>Quality Assurance:</u></b> <br/> We partner with leading manufacturers to ensure that all our products meet the highest quality standards. You can trust that you’re getting reliable, long-lasting power.</p>
            <p><i className="fa fa-check text-primary me-3"></i><b><u>Competitive Pricing:</u></b> <br/> We believe in providing value without compromising on quality. Our competitive pricing ensures you get the best deals on top-notch batteries.</p>
            <p><i className="fa fa-check text-primary me-3"></i><b><u>Fast Shipping:</u></b> <br/> We know you want your products quickly. Our efficient shipping process ensures your order arrives on time, every time.</p>
          </div>
          <div className="col-lg-6">
            <div className="rounded overflow-hidden">
              <div className="row g-0">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
              <div style={{backgroundColor:"darkturquoise"}} className="text-center  py-5 px-4">
              
              <img className="img-fluid mb-4" src={brand1} alt="" />
              </div>
                 
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                  <div className="text-center bg-secondary py-5 px-4">
              <img className="img-fluid mb-4" src={brand2} alt="" />
                   
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                  <div style={{backgroundColor:"blue"}} className="text-center  py-5 px-4">
                    <img className="img-fluid mb-4" src={brand3} alt="" />
                    
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                  <div className="text-center bg-primary py-5 px-4">
                    <img className="img-fluid mb-4" src={brand4} alt="" />
                   
                  </div>
                </div>
                <div className="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                  <div  className="text-center bg-primary py-5 px-4">
                    <img className="img-fluid mb-4" src={brand5} alt="" />
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
